<template>
  <div v-if="address" class="address-display">
    <div v-if="address.street_address" class="mb-1 mt-2">
      {{ address.street_address }}
    </div>
    <div v-if="address.locality" class="mb-1">
      {{ address.locality }}{{ address.region ? `, ${address.region}` : '' }}{{ address.postal_code ? ` ${address.postal_code}` : '' }}
    </div>
    <div v-if="address.country" class="mb-2">
      {{ address.country }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Address } from "@saflib/openapi";

defineProps<{
  address?: Address | null;
}>();
</script>

<style scoped>
.address-display {
  line-height: 1.4;
}
</style>